import React from 'react';
import './App.css';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { DifferentiationSection } from './components/DifferentiationSection';
import { AuthoritySection } from './components/AuthoritySection';
import { BooksSection } from './components/BooksSection';
import { TransformationSection } from './components/TransformationSection';
import { ProcessSection } from './components/ProcessSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { AmbientAudio } from './components/AmbientAudio';

function App() {
  return (
    <div className="App">
      <Navigation />
      <main>
        <HeroSection />
        <ProblemSection />
        <DifferentiationSection />
        <AuthoritySection />
        <BooksSection />
        <TransformationSection />
        <ProcessSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <AmbientAudio />
    </div>
  );
}

export default App;
